module.exports = __webpack_public_path__ + "static/Kinderschokolade-d37bd819f069f87c3a186d75169682ce.png";